import { Select } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { searchSelectProps } from 'src/components/helpers';

export const crecerSteps = [
  { text: 'Conectar', key: 'conectar', value: 'conectar' },
  { text: 'Encuentro', key: 'encuentro', value: 'encuentro' },
  { text: 'Vida', key: 'vida', value: 'vida' },
  { text: 'Influencia', key: 'influencia', value: 'influencia' },
  { text: 'Bautizo', key: 'bautizo', value: 'bautizo' },
];

export const seminaryEvent = [
  { text: 'Para Siempre', key: 'ParaSiempre', value: 'ParaSiempre' },
  { text: 'Proyecto Matrimonio', key: 'ProyectoMatrimonio', value: 'ProyectoMatrimonio' },
  { text: 'Relaciones Sanas', key: 'RelacionesSanas', value: 'RelacionesSanas' },
  {
    text: 'Transformacion Empresarial',
    key: 'TransformacionEmpresarial',
    value: 'TransformacionEmpresarial',
  },
  { text: 'Escuela de Heroes', key: 'EscueladeHeroes', value: 'EscueladeHeroes' },
  { text: 'Ruta 128', key: 'Ruta128', value: 'Ruta128' },
];

export const reportTypes = [
  { text: 'Crecer', key: 'crecer', value: 'crecer' },
  { text: 'Seminarios', key: 'seminarios', value: 'seminarios' },
];

export const CrecerReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #001574 0%, #001c71 100%);
  padding: 40px 30px;
  border-radius: 20px;
  margin: 30px auto;
  width: 100%;
  max-width: 900px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  color: white;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 20px;
  }

  .report-content {
    position: relative;
    z-index: 2;
    width: 100%;
    text-align: center;
  }

  .ui.attached.tabular.menu {
    .item {
      &,
      &:hover {
        color: white;
      }
    }
    .item {
      &.active {
        &,
        &:hover {
          color: black;
        }
      }
    }
  }

  h1 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 10px;
    background: linear-gradient(45deg, #fff, #f0f0f0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    margin: 10px 0 5px 0;
    font-size: 1rem;
    opacity: 0.9;

    &.small {
      margin: 0 0 0 0;
      opacity: 0.8;
      font-style: italic;
      color: #fff;
    }
  }

  .filters-section {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    margin: 20px auto;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 100%;
    max-width: 600px;
  }

  .date-range-section {
    margin: 25px 0;

    label {
      display: block;
      font-weight: 600;
      margin-bottom: 0px;
      color: #fff;
      font-size: 1.1rem;
    }
  }

  .single-date-section {
    margin: 25px 0 0 0;

    label {
      display: block;
      font-weight: 600;
      margin-bottom: 10px;
      color: #fff;
      font-size: 1.1rem;
    }
  }

  .selectorCheck {
    width: 100%;
    margin: 20px 0;

    .ui.selection.dropdown {
      background: rgba(255, 255, 255, 0.9);
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        border-color: rgba(255, 255, 255, 0.6);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &.active {
        border-color: #fff;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
      }
    }
  }

  .ui.button {
    background: linear-gradient(45deg, #4caf50, #45a049);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 15px 30px;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 25px 5px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
      background: linear-gradient(45deg, #45a049, #4caf50);
    }

    &:active {
      transform: translateY(0);
    }

    &:disabled {
      background: rgba(255, 255, 255, 0.3);
      color: rgba(255, 255, 255, 0.7);
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }

  .ui.segment.active {
    background: rgba(255, 255, 255, 0);
    color: #001574;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    padding: 25px 20px;
    margin: 20px 15px;

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .filters-section {
      padding: 20px;
    }

    .ui.button {
      padding: 12px 24px;
      font-size: 1rem;
    }
  }

  .count-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 15px;
    padding: 0 20px 20px;
  }

  .count-card {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    padding: 20px 15px;
    text-align: center;
    overflow: hidden;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }

    .count-number {
      font-size: 2rem;
      font-weight: 700;
      color: #fff;
      margin-bottom: 8px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    .count-label {
      font-size: 0.9rem;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 500;
      letter-spacing: 0.5px;
    }
  }
`;

export function CrecerFilters({ inputs, onSelectChange }) {
  return (
    <>
      <div className="selectorCheck">
        <Select
          placeholder="Tipo"
          {...searchSelectProps({
            name: 'type',
            value: inputs.type,
            handler: onSelectChange,
            options: reportTypes,
          })}
        />
      </div>
      {inputs.type === 'crecer' && (
        <div className="selectorCheck">
          <Select
            placeholder="Paso de Crecer"
            {...searchSelectProps({
              name: 'step',
              value: inputs.step,
              handler: onSelectChange,
              options: crecerSteps,
            })}
          />
        </div>
      )}
      {inputs.type === 'seminarios' && (
        <div className="selectorCheck">
          <Select
            placeholder="Seminario"
            {...searchSelectProps({
              name: 'seminary',
              value: inputs.seminary,
              handler: onSelectChange,
              options: seminaryEvent,
            })}
          />
        </div>
      )}
    </>
  );
}
